import { render, staticRenderFns } from "./weapp.vue?vue&type=template&id=e85dc2c8&"
import script from "./weapp.vue?vue&type=script&lang=js&"
export * from "./weapp.vue?vue&type=script&lang=js&"
import style0 from "./weapp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports